import { UpdateStatusRequest, VisitaInfo } from "../types/visitas";
import { apiSlice } from "./baseQuery";
import { DealsEndpointTags, PipelineEndpointTags, VisitasEndpointTags } from "./utils";

const BASE_URL = "/api/visitas";

export const visitasApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getVisitaById: build.query<VisitaInfo, number>({
            query: (visitaId) => BASE_URL + `/${visitaId}`,
            providesTags: [VisitasEndpointTags.GET_VISITA_BY_ID]
        }),
        updateStatus: build.mutation<void, UpdateStatusRequest>({
            query: (request) => ({
                url: BASE_URL + `/${request.visitaId}/update-status`,
                method: "PUT",
                body: {
                    status: request.status,
                    intenciones: request.intenciones,
                },
            }),
            invalidatesTags: [
                VisitasEndpointTags.GET_VISITA_BY_ID,
                DealsEndpointTags.GET_DEAL_INFO_BY_ID,
            ],
        }),
    }),
});

export const {
    useGetVisitaByIdQuery,
    useUpdateStatusMutation,
} = visitasApi;